/* jshint esversion: 6, -W097 */
/* globals require, module */
'use strict';
/**
 * Utility module for holding general common code between the main Enervee Angular applications.
 */

const commonModule = require('@utils/common/commonModule');

const solarOverlayDirective = require('./solarOverlayDirective');

const solarModule = angular
    .module('enervee_utils.solar', [
        commonModule.name,
    ])
    .directive('solarOverlay', solarOverlayDirective);

module.exports = solarModule;